<template>
  <section class="section">
    <h1>{{ $t('home.heading') }}</h1>
    <div class="wrapper">
      <ul class="stats">
        <li>
          <span v-if="['abg_manager', 'abg_user'].includes(this.user.role)">{{ $t('home.orders.new') }}</span>
          <span v-if="['client_manager', 'client_user'].includes(this.user.role)">{{ $t('home.orders.awaiting_acceptance') }}</span>
          <span>{{ stats.totalTbd }}</span>
        </li>
        <li>
          <span>{{ $t('home.orders.inProgressUser') }}</span>
          <span>{{ stats.totalInProgressUser }}</span>
        </li>
        <li>
          <span>{{ $t('home.orders.inProgress') }}</span>
          <span>{{ stats.totalInProgress }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<style scoped>
  .section {
    margin: 100px 0;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh - 300px);
  }

  .stats {
    margin: 0;
    padding: 0;
    background-color: white;
    border: 2px solid #e9e9e9;
    border-radius: 5px;
    box-shadow: 6px 6px 22px -15px rgba(130, 130, 130, 1);
    list-style-type: none;
  }

  .stats > li {
    display: flex;
  }

  .stats > li > span {
    display: inline-block;
    padding: 20px;
  }

  .stats > li > span:nth-child(2) {
    margin-left: auto;
    font-weight: 600;
    font-size: 1.8rem;
  }
</style>

<script>
  export default {
    props: [ 'user' ],
    data() {
      return {
        stats: {}
      };
    },
    beforeCreate: async function() {
      let statusFilter = '';
      let userFilter = '';
      if (['abg_manager', 'abg_user'].includes(this.user.role)) {
        statusFilter = 'status=new&';
        userFilter = `assigned_user_id=${this.user.id}&`;
      } else if (['client_manager', 'client_user'].includes(this.user.role)) {
        statusFilter = 'status=awaiting_acceptance&';
        userFilter = `principal_id=${this.user.id}&`;
      }

      const data = await Promise.all([
        fetch(`/api/order?${statusFilter}per_page=1`),
        fetch(`/api/order?${userFilter}status=in_progress&per_page=1`),
        fetch(`/api/order?status=in_progress&per_page=1`)
      ]);
      const json = await Promise.all(data.map(response => response.json()));
      this.stats = {
        totalTbd: json[0].total?.toString() || '0',
        totalInProgressUser: json[1].total?.toString() || '0',
        totalInProgress: json[2].total?.toString() || '0'
      };
    }
  }
</script>
